import { FC, useContext } from "react";
import { initialState } from "./reducer";
import ActionDashBoardFilter from "src/components/ActionDashBoardFilter";
import { APIEndpoints } from "src/types/apiTypes";
import { manufactureTabsConfig } from "./tabConfigs";
import ActionDashboard from "src/components/manufacturer/actionDashboard";
import { AuthContext } from "src/context/authContext";
// import FooterText from "src/components/footerText";

const ActionDashboardManufactureListing: FC = () => {
  const { userData } = useContext(AuthContext);
  return (
    <>
      <ActionDashboard
        apiEndpoint={APIEndpoints.TODO_ACTION_DASHBOARD_STATISTICS}
        userListEndpoint={APIEndpoints.USER_LIST_STATISTICS}
        initialState={initialState}
        FilterComponent={ActionDashBoardFilter}
        allowedRoles={["Manufacturer", "regional_manager", "district_manager", "area_manager","fam_rm","fam_am","rep"]}
        tabs={manufactureTabsConfig(userData || {} as any)}
      />
      {/*<FooterText footerType="black" />*/}
    </>
  );
};

export default ActionDashboardManufactureListing;
